import React, { useState } from "react";
import axios from 'axios'
import './contact.css';
import {Col, Row} from 'react-bootstrap';
import {AiFillPhone, AiOutlineMail} from 'react-icons/ai'


const EmailSend = () => {
  
  const [msg,setMsg] = useState('');
  const [user, setUser] = useState({
    to: "",
    subject: "",
    description: ""
  });
 
  const { to, subject, messagge} = user;
  const onInputChange = e => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };
 
  const onSubmit = async e => {
    e.preventDefault();
    if (to.length>0 && messagge.length>0 && subject.length>0){
      await axios.post("https://toxfinderserver.azurewebsites.net/users/",user)
    //await axios.post("https://toxifinder.herokuapp.com/users/",user)
    //await axios.post("http://192.168.1.187:5000/users/",user)
   .then(response => setMsg(response.data.respMesg))
    }
    else{setMsg('Error')}
  };
  return (
    <div>
      <Row className='d-flex justify-content-center mx-auto Row2' style={{marginTop:'20%'}}>
            <Col xs='6' sm='6' md='6' lg='6' className='d-flex align-items-center flex-column text-center altCol'>
         <h3 className="text-center mb-2 mt-4"><b>Formulario Contacto/Sugerencias</b></h3>
      <div class="row" style={{width: 'fit-content'}}>  
       <div className="col-sm-12 mx-auto shadow p-5">
        <h6 className="text-center mb-2">Envíanos cualquier consulta rellenando la información de abajo</h6>
           <p class="mb-3 mt-2" style={{color:"gray",textAlign:"center"}}><b>{msg}</b></p>
          <div className="form-group mb-3">
            <input
              type="email"
              className="form-control form-control-lg"
              placeholder="Correo"
              name="to"
              onChange={onInputChange}
              value={to}
              required
            />
          </div>
          <div className="form-group  mb-4 ">
            <input
              type="text"
              className="form-control form-control-lg"
              placeholder="Asunto"
              name="subject"
              onChange={onInputChange}
              value={subject}
              required
            />
          </div>
          <div className="form-group mb-4">
            <textarea
              type="text"
              className="form-control form-control-lg"
              placeholder="Mensaje"
              name="messagge"
              onChange={onInputChange}
              value={messagge}
              required
            />
          </div>
          <div className="myButton">
          <h4 onClick={onSubmit}>Enviar</h4>
          </div>
      </div>
    </div>
    </Col>
    <Col xs='6' sm='6' md='6' lg='6' className='d-flex align-items-center flex-column text-center altCol marginAlt'>
    <div className="contact-wrap">
    <div>
          <div class="contact-info">
            <h4>Información de Contacto</h4>
            <p>Puedes escribirnos al correo:</p>
            <li class="d-flex">
                <span class="wrap-icon icon-envelope mr-3">
                <AiOutlineMail/></span>
                <a className="textlink" href="mailto:toxifinder@gmail.com"><i>toxifinder@gmail.com</i></a>
              </li>
              <p></p>
              <p>Número de emergencias Toxicológicas del CITUC:</p>
              <li class="d-flex">
                <span class="wrap-icon icon-telephone mr-3">
                <AiFillPhone/></span>
                <span class="text"><b>+56 2 2 635 3800</b></span>
              </li>
          </div>
        </div>
        </div>
    </Col>
    </Row>
    <div style={{marginBottom:'15%'}}></div>
  </div>  
  );
};
 
export default EmailSend;